import { memo } from "react";
import { UserIcon } from "@heroicons/react/20/solid";
import { Handle } from "@xyflow/react";
import { NODE_WIDTH_STYLE, ROTATED_LABEL_STYLE } from "./shared-styles";
import { TruncatedResourceName } from "./TruncatedResourceName";

interface Data {
  title: string;
  label: string;
  bgColor: string;
  color: string;
  mode: "simple" | "full";
  step: {
    id: string;
    title: string;
    summary: string;
    name: string;
    actor: { name: string };
  };
  showTarget?: boolean;
  showSource?: boolean;
}

function classNames(...classes: any) {
  return classes.filter(Boolean).join(" ");
}

export default memo(function UserNode({
  data,
  sourcePosition,
  targetPosition,
}: any) {
  const {
    mode,
    step,
    showTarget: _showTarget = true,
    showSource: _showSource = true,
  } = data as Data;

  const { summary, actor: { name } = {} } = step;
  const displayName = name || step.name || step.title || "Actor";

  return (
    <div
      className={classNames(
        `rounded-md border flex justify-start bg-[rgb(var(--ec-card-bg))] text-[rgb(var(--ec-page-text))] border-yellow-400`,
        mode === "full" ? "min-h-[5em]" : "min-h-[2em]",
      )}
      style={NODE_WIDTH_STYLE}
    >
      <div
        className={classNames(
          "bg-gradient-to-b from-yellow-400 to-yellow-600 relative flex flex-col items-center w-5 justify-between rounded-l-sm text-orange-100-500",
          `border-r-[1px] border-yellow-500`,
        )}
      >
        <UserIcon className="w-4 h-4 opacity-90 text-white mt-1" />
        {mode === "full" && (
          <span
            className="text-center text-[9px] text-white font-bold uppercase mb-4"
            style={ROTATED_LABEL_STYLE}
          >
            ACTOR
          </span>
        )}
      </div>
      <div className="p-1 flex-1 min-w-0">
        {targetPosition && <Handle type="target" position={targetPosition} />}
        {sourcePosition && <Handle type="source" position={sourcePosition} />}

        {(!summary || mode !== "full") && (
          <div className="h-full min-w-0">
            <TruncatedResourceName
              as="div"
              value={displayName}
              tooltipBorderColor="#eab308"
              className="text-sm font-bold truncate pb-0.5"
            >
              {displayName}
            </TruncatedResourceName>
            {mode === "simple" && (
              <div className="w-full text-right">
                <span className=" w-full text-[10px] text-[rgb(var(--ec-page-text-muted))] font-light block pt-0.5 pb-0.5 ">
                  Event
                </span>
              </div>
            )}
          </div>
        )}

        {summary && mode === "full" && (
          <div>
            <div
              className={classNames(
                mode === "full"
                  ? `border-b border-[rgb(var(--ec-page-border))]`
                  : "",
              )}
            >
              <TruncatedResourceName
                as="div"
                value={displayName}
                tooltipBorderColor="#eab308"
                className="text-xs font-bold truncate pb-0.5"
              >
                {displayName}
              </TruncatedResourceName>
            </div>
            {mode === "full" && (
              <div className="divide-y divide-[rgb(var(--ec-page-border))] ">
                <div className="leading-3 py-1">
                  <span className="text-[8px] font-light">{summary}</span>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
});
